export default {
  fontFamily: Styles.fontFamily.body,
};
